import { render, staticRenderFns } from "./InstCheckAppointments.vue?vue&type=template&id=76a9101e&v-if=apiResponse"
import script from "./InstCheckAppointments.vue?vue&type=script&lang=js"
export * from "./InstCheckAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports